export enum SearchCategory {
  Contacts = 'contacts',
  Institutions = 'institutions',
  Events = 'events',
  Funds = 'funds'
}
